/**
 * The agent page's route: its tabs and `?tab=` (decision 0071). Its own module so the router validates the search
 * without importing the page's model (and the chat's parts it reads); `agent-page-model` re-exports it.
 */
export const AGENT_TABS = ["now", "knows", "history", "page", "settings"] as const
export type AgentTab = (typeof AGENT_TABS)[number]
/** The phone's segmented control; Settings sits under ⋯ (spec §3.1). */
export const PHONE_TABS: ReadonlyArray<AgentTab> = ["now", "knows", "history", "page"]

export const TAB_WORD: Readonly<Record<AgentTab, string>> = {
  now: "Now",
  knows: "Knows",
  history: "History",
  page: "Page",
  settings: "Settings",
}

export interface AgentSearch {
  /** Absent = Now. */
  readonly tab?: Exclude<AgentTab, "now">
}

/**
 * `?tab=now|knows|history|page|settings`; the default (Now) is left out of the URL. `about` (before decision 0084)
 * reads as `page`, so old links still work.
 */
export const validateAgentSearch = (search: Record<string, unknown>): AgentSearch => {
  const raw = search.tab === "about" ? "page" : search.tab
  const tab = AGENT_TABS.find((t) => t === raw)
  return tab && tab !== "now" ? { tab } : {}
}
